import $ from "jquery";
import registry from "@patternslib/patternslib/src/core/registry";
import "./advancedrecurrence/pattern";
import "./eventview/pattern";
import "./insertlink/pattern";
import "./gmap_autocomplete/pattern";
import "./custom_mockup_patterns/structure/structure";

registry.init();

$(document).on('DOMNodeInserted', 'em', function() {
    if (this.classList.contains('invalid-feedback')){
        if (this.parentElement.classList.contains('field')){
            this.parentElement.classList.add('error');
        }
    }
});

$(document).on('DOMNodeRemoved', 'em', function() {
    if (this.classList.contains('invalid-feedback')){
        if (this.parentElement.classList.contains('field')){
            this.parentElement.classList.remove('error');
        }
    }
});

$(function() {
let div_login = $("div#tceq-special-login-staff");
let portal_url = $("body").data('portalUrl');
if (div_login.length > 0 && portal_url !== undefined) {
    $.ajax({
        url:      portal_url + "/@@show-login",
        type:     'GET',
        async:    true,
        success: function(data, status, xhr) {
            if (data) {
                let login_link = $("<a>Log in</a>")
                                .attr("href", portal_url + "/login")
                                .attr("title", "Log in")
                                .attr("id", "tceq-login")
                                .attr("data-pat-plone-modal", JSON.stringify({"prependContent": ".portalMessage", "title": "Log in", "width": "26em", "actionOptions": {"redirectOnResponse": true}}))
                                .addClass("pat-plone-modal btn btn-success");
                div_login.append(login_link);
                registry.scan(div_login);
            }
        },
    })
}
});

// $(function() {
// if ($('div.tw-tile-title').length > 0){
//     // Taken from https://dev.twitter.com/web/javascript/loading
//     window.twttr = (function(d, s, id) {
//     var js, fjs = d.getElementsByTagName(s)[0],
//         t = window.twttr || {};
//     if (d.getElementById(id)) return t;
//     js = d.createElement(s);
//     js.id = id;
//     js.src = "//platform.twitter.com/widgets.js";
//     fjs.parentNode.insertBefore(js, fjs);

//     t._e = [];
//     t.ready = function(f) {
//         t._e.push(f);
//     };

//     return t;
//     }(document, "script", "twitter-wjs"));

//     window.twttr.ready(
//     function (twttr) {
//         twttr.events.bind(
//         'loaded',
//         function (event) {
//             event.widgets.forEach(function (widget) {
//             $(widget).contents().find(".timeline-Tweet-media").css("display", "none");
//             });
//         }
//         );

//         $("div.mosaic-toolbar").on("selectedtilechange",function(){
//             twttr.widgets.load();
//         });

//         twttr.widgets.load();
//     }
//     );
// }
// });

$(document).on('click', ".expand-hidden-links", function(){
    var spotlight = $(this).parents(".tceq-panel-spotlight");
    $('svg#visible-links-mask', spotlight).toggle();
    $('.expand-hidden-links>i', spotlight).toggleClass('fa-sort-asc fa-sort-desc');
});


$(document).on('DOMNodeInserted', 'iframe', function() {
    // #2795974: Remove frameborder from all iframes
    $('iframe').removeAttr('frameborder').css({'border': 'none','width':'100%'});
    // We need to redraw the iframes now
    var ifr = $('iframe:visible')
    ifr.hide(100, function() {
        $( this ).show();
    });
});


function updateLocationVisibility(selectedValue) {
    const inPersonLocation = document.querySelector('.event-in-person');
    const virtualLocation = document.querySelector('.event-virtual');

    if (selectedValue === "In Person") {
        inPersonLocation.classList.remove('disabled-overlay');
        virtualLocation.classList.add('disabled-overlay');
    } else if (selectedValue === "Virtual") {
        inPersonLocation.classList.add('disabled-overlay');
        virtualLocation.classList.remove('disabled-overlay');
    } else if (selectedValue === "Both") {
        inPersonLocation.classList.remove('disabled-overlay');
        virtualLocation.classList.remove('disabled-overlay');
    }

    const checkbox = document.getElementById("form-widgets-ITCEQEventType-event_location-widgets-no_link-0");
    const isChecked = checkbox.checked;
    const virtualLinkDiv = virtualLocation.querySelector('#virtual_link');
    if (isChecked){
        virtualLinkDiv.classList.add('disabled-overlay');
    } else {
        virtualLinkDiv.classList.remove('disabled-overlay');
    }

}

const eventFormat = document.querySelector('input[name="form.widgets.ITCEQEventType.event_location.widgets.event_format"]:checked')?.value || '';

updateLocationVisibility(eventFormat);

    document.addEventListener('change', function(e) {
    const target = e.target;
    if (target && target.matches('input[name="form.widgets.ITCEQEventType.event_location.widgets.event_format"]')) {
        updateLocationVisibility(target.value);
    }
    if (target && target.matches('input#form-widgets-ITCEQEventType-event_location-widgets-no_link-0')) {
        updateLocationVisibility();
    }
});

const selectElement = document.getElementById("form-widgets-ITCEQEventType-event_type");

if (selectElement) {
    // Bind the handleSelectChange function to both change event and initial load
    selectElement.addEventListener("change", handleSelectChange);
    handleSelectChange(); // Call it on page load
}

function handleSelectChange() {
    const selectElement = document.getElementById("form-widgets-ITCEQEventType-event_type");
    const selectedValue = selectElement ? selectElement.value : null;

    const publicHearingsAndMeetingsIds = [
        "formfield-form-widgets-ITCEQEventType-regulated_entity_name",
        "formfield-form-widgets-ITCEQEventType-facility_county",
        "formfield-form-widgets-ITCEQEventType-facility_zip",
        "formfield-form-widgets-ITCEQEventType-no_regulated",
        "formfield-form-widgets-ITCEQEventType-permit_number",
        "formfield-form-widgets-ITCEQEventType-permit_type",
        "formfield-form-widgets-ITCEQEventType-meeting_type",
        "formfield-form-widgets-ITCEQEventType-soah_docket_number"
    ];
    const publicHearingsOnRulesIds = ["formfield-form-widgets-ITCEQEventType-rule_project_number"];

    // Show or hide elements based on the selected option
    if (selectedValue === "Public hearings and meetings on proposed permits") {
        toggleVisibility(publicHearingsAndMeetingsIds, true);
        toggleVisibility(publicHearingsOnRulesIds, false);
    } else if (selectedValue === "Public hearings on proposed rules") {
        toggleVisibility(publicHearingsAndMeetingsIds, false);
        toggleVisibility(publicHearingsOnRulesIds, true);
    } else {
        toggleVisibility(publicHearingsAndMeetingsIds, false);
        toggleVisibility(publicHearingsOnRulesIds, false);
    }
}

// Function to toggle visibility of elements by IDs
function toggleVisibility(ids, show) {

    const requiredFieldIds = [
        "formfield-form-widgets-ITCEQEventType-regulated_entity_name",
        "formfield-form-widgets-ITCEQEventType-facility_county",
        "formfield-form-widgets-ITCEQEventType-facility_zip",
        "formfield-form-widgets-ITCEQEventType-permit_number",
        "formfield-form-widgets-ITCEQEventType-permit_type",
        "formfield-form-widgets-ITCEQEventType-meeting_type",
        "formfield-form-widgets-ITCEQEventType-rule_project_number"
    ];

    const no_regulated_disable = [
        "formfield-form-widgets-ITCEQEventType-regulated_entity_name",
        "formfield-form-widgets-ITCEQEventType-facility_county",
        "formfield-form-widgets-ITCEQEventType-facility_zip"
    ];

    ids.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
            element.style.display = show ? "block" : "none";

            if (requiredFieldIds.includes(id)) {
                const label = element.querySelector("label");
                const formElements = element.querySelectorAll("input[name], select[name], textarea[name]");

                if (show) {
                    if (label && !label.querySelector(".required")) {
                        const span = document.createElement("span");
                        span.className = "required";
                        span.title = "Required";
                        label.appendChild(span);
                    }
                    formElements.forEach(formElement => {
                        let add_required = true;
                        if (no_regulated_disable.includes(id)){
                            const no_regulated_checkbox = document.getElementById("form-widgets-ITCEQEventType-no_regulated-0");
                            add_required = !no_regulated_checkbox.checked;
                        }
                        if (add_required){
                            if (!formElement.classList.contains("pat-select2")) {
                                formElement.setAttribute("required", "required");
                            }
                        }
                    });
                } else {
                    const requiredSpan = label ? label.querySelector(".required") : null;
                    if (requiredSpan) {
                        requiredSpan.remove();
                    }
                    formElements.forEach(formElement => {
                        if (!formElement.classList.contains("pat-select2")) {
                            formElement.removeAttribute("required");
                        }
                    });
                }
            }
        }
    });
    const formElement = document.getElementById("form");
    if (formElement) {
        const event = new CustomEvent("pat-update");
        formElement.dispatchEvent(event);
    }

}

const no_regulated_checkbox = document.getElementById("form-widgets-ITCEQEventType-no_regulated-0");

if (no_regulated_checkbox) {
    no_regulated_checkbox.addEventListener("change", noRegulatedHideShow);
    noRegulatedHideShow();
}

function noRegulatedHideShow (){
    const no_regulated_checkbox = document.getElementById("form-widgets-ITCEQEventType-no_regulated-0");
    const isChecked = no_regulated_checkbox.checked;

    const no_regulated_disable = [
        "formfield-form-widgets-ITCEQEventType-regulated_entity_name",
        "formfield-form-widgets-ITCEQEventType-facility_county",
        "formfield-form-widgets-ITCEQEventType-facility_zip"
    ];
    if (isChecked){
        no_regulated_disable.forEach(id => {
            const element = document.getElementById(id);
            if (element) {
                element.classList.add('disabled-overlay');
                const formElements = element.querySelectorAll("input[name], select[name], textarea[name]");
                formElements.forEach(formElement => {
                    if (!formElement.classList.contains("pat-select2")) {
                        formElement.removeAttribute("required");
                    }
                });
            }
        });
    } else {
        no_regulated_disable.forEach(id => {
            const element = document.getElementById(id);
            if (element && element.style.display !== 'none') {
                element.classList.remove('disabled-overlay');
                const formElements = element.querySelectorAll("input[name], select[name], textarea[name]");
                formElements.forEach(formElement => {
                    if (!formElement.classList.contains("pat-select2")) {
                        formElement.setAttribute("required", "required");
                    }
                });
            }
        });
    }
}


const permit_type_element = document.querySelector('select#form-widgets-ITCEQEventType-permit_type');
const meeting_type_element = document.querySelector('select#form-widgets-ITCEQEventType-meeting_type');

function removeOption(selectElement, valueToRemove, idContains) {
    if (selectElement) {
        let option = selectElement.querySelector(`option[value="${valueToRemove}"]`);
        if (option) {
            selectElement.removeChild(option);
        }

        option = selectElement.querySelector(`option[id*="${idContains}"]`);
        if (option) {
            selectElement.removeChild(option);
        }
    }
}

removeOption(permit_type_element, '--NOVALUE--', 'permit_type-missing');
removeOption(meeting_type_element, '--NOVALUE--', 'meeting_type-missing');

const labelElements = document.querySelectorAll('label');

labelElements.forEach(label => {
    label.addEventListener('click', (event) => {
        event.preventDefault();
    });
});

window.onload = function () {
    const form = document.getElementById('form');

    if (form) {
        form.addEventListener('submit', function (event) {
            const selectedRadio = document.querySelector(
                'input[name="form.widgets.ITCEQEventType.event_location.widgets.event_format"]:checked'
            );

            if (selectedRadio) {
                if (selectedRadio.value === 'In Person') {
                    const virtualMeetingInput = document.getElementById(
                        'form-widgets-ITCEQEventType-event_location-widgets-link_to_virtual_meeting'
                    );
                    if (virtualMeetingInput) {
                        virtualMeetingInput.value = '';
                    }
                } else if (selectedRadio.value === 'Virtual') {
                    const fieldsToClear = [
                        'form-widgets-ITCEQEventType-event_location-widgets-address',
                        'form-widgets-ITCEQEventType-event_location-widgets-city',
                        'form-widgets-ITCEQEventType-event_location-widgets-zip',
                        'form-widgets-ITCEQEventType-event_location-widgets-county'
                    ];
                    fieldsToClear.forEach(id => {
                        const input = document.getElementById(id);
                        if (input) {
                            input.value = '';
                        }
                    });
                }
            }
        });
    }
};
